import React from 'react';
import './Route404.css'

const Route404 = () => {
    return (
        <div className='bg404'>
            <h3 className='text-center pt-5'>Invalid request!</h3>
        </div>
    );
};

export default Route404;